;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:zestlife-web":true});}catch(e){}}();import React from "react"
import styles from "./styles.module.scss"
import Container from "@mui/material/Container"
import Grid from "@mui/material/Grid"

interface SectionContainerProps {
  children: React.ReactNode
  color?: string
}

export default function SectionContainer({
  children,
  color,
}: SectionContainerProps) {
  const getColorStyle = () => {
    if (color == "blue") {
      return styles["b"]
    }
    if (color == "faded-blue") {
      return styles["fb"]
    }
    if (color == "faded-blue-news-paper-header") {
      return styles["fbn"]
    }
    return ""
  }

  return (
    <div className={`${getColorStyle()} ${styles["container"]}`}>
      <Container disableGutters maxWidth={"lg"}>
        <Grid
          container
          spacing={2}
          columns={9}
          sx={{
            justifyContent: "center",
            margin: 0,
          }}
        >
          <Grid
            size={{
              xs: 8,
              sm: 7,
              md: 7,
              lg: 8.5,
            }}
            sx={{
              padding: 0,
            }}
          >
            {children}
          </Grid>
        </Grid>
      </Container>
    </div>
  )
}
